import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=de6f9a08&"
import script from "./AnimatedNumber.vue?vue&type=script&lang=js&"
export * from "./AnimatedNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de6f9a08')) {
      api.createRecord('de6f9a08', component.options)
    } else {
      api.reload('de6f9a08', component.options)
    }
    module.hot.accept("./AnimatedNumber.vue?vue&type=template&id=de6f9a08&", function () {
      api.rerender('de6f9a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AnimatedNumber.vue"
export default component.exports